var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"367611e2aea334b43a411b6d8d14cee746e5fa53"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["gatsby@homepl"]={id:"367611e2aea334b43a411b6d8d14cee746e5fa53"};
      